export default {
    dashboard: 'Tableau de bord'
};
